/** @jsx jsx */

import { css, jsx } from '@emotion/react';
var gridStyles = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, minmax(max-content, 1fr))'
});
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */
var WeekDayGrid = function WeekDayGrid(_ref) {
  var testId = _ref.testId,
    children = _ref.children;
  return (
    // eslint-disable-next-line @repo/internal/react/use-primitives
    jsx("div", {
      "data-testid": testId,
      css: gridStyles
    }, children)
  );
};
export default WeekDayGrid;